const REGIONS = ['', '/kz'];

export function patchPath(path: string) {
  return REGIONS.map((region) => region + (path === '/' ? '' : path));
}
